import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";

export const UPLOAD_IMG_REQUEST = "UPLOAD_IMG_REQUEST";
export const UPLOAD_IMG_SUCCESS = "UPLOAD_IMG_SUCCESS";
export const UPLOAD_IMG_FAIL = "UPLOAD_IMG_FAIL";

export const uploadImg = (data: any) => (dispatch: any): any => {
  dispatch({ type: UPLOAD_IMG_REQUEST });

  const token = getToken();

  return api
    .uploadImg(token, data)
    .then((response: AxiosResponse) => {
      const name: string = get(response, "data", {});
      dispatch({
        type: UPLOAD_IMG_SUCCESS,
        payload: name
      });

      return name;
    })
    .catch(err => {
      dispatch({
        type: UPLOAD_IMG_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
